<template>
  <div class="basic-setting-content pl16 pr16">
    <!--商品详情-->
    <div class="common-form" style="font-size: 20px">商品详情</div>
    <!--    <el-form-item label="详情类型：" class="labelStyle">-->
    <!--      <el-radio-group v-model="form.model.isPicture">-->
    <!--        <el-radio :label="0">图文</el-radio>-->
    <!--        <el-radio :label="1">纯图</el-radio>-->
    <!--      </el-radio-group>-->
    <!--    </el-form-item>-->
    <!--内容-->
    <!--    <el-form-item label="详情内容：" class="labelStyle" v-if="form.model.isPicture == 0">-->
    <!--      <div class="edit_container">-->
    <!--        <Uediter :text="form.model.content" :config="ueditor.config" ref="ue"-->
    <!--                 @contentChange="contentChangeFunc"></Uediter>-->
    <!--      </div>-->
    <!--    </el-form-item>-->
    <el-form-item label="详情图片：" class="labelStyle">
      <div class="p-h-15 p-v-15"
           style="height: 545px;background: #f9f9fa;margin-bottom: 30px;">
        <el-row :gutter="10" type="flex" class="w-full h-full" style="margin: 0">
          <el-col :span="1.5" class="h-full flex-shrink-0" style="padding-left: 0;width: 394px">
            <div class="w-full h-full border b-r-5"
                 style="display: flex;flex-direction: column">
              <div class="color-33 p-l-10 fs-12">页面预览</div>
              <div class="w-full flex flex-1 scrollbar o-y-auto bg-white"
                   style="flex-direction: column">
                <img :src="item.filePath" alt="" style="width:100%;object-fit: cover"
                     v-for="item in form.model.contentImage"/>
              </div>
            </div>
          </el-col>
          <el-col class=" h-full" style="padding-right: 0">
            <div class=" border b-r-5 w-full h-full p-h-10"
                 style="display: flex;flex-direction: column">
              <div class="w-full flex j-center">
                <div class="fs-14 color-33 flex-1 m-t-10" style="line-height: 1.5;">
                  详情编辑
                  <div style="color: hsla(220,3%,55%,.8)" class="color-33 fs-12">
                    已上传{{
                      form.model.contentImage.length
                    }}/50张，拖拽可调整顺序，单张详情图宽高比不超5000*20000px，大小5M内，仅支持jpg/jpeg/png格式
                  </div>
                </div>
              </div>
              <div class="draggable-list">
                <draggable class="wrapper" v-model="form.model.contentImage">
                  <transition-group>
                    <div class="item" v-for="(item, index) in form.model.contentImage" :key="item.filePath">
                      <el-image :src="item.filePath" style="width: 100%;height: 100%"
                                :preview-src-list="[item.filePath]"/>
                      <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                        class="el-icon-close"></i></a>
                    </div>
                  </transition-group>
                </draggable>
                <div class="item img-select" @click="openUpload"><i class="el-icon-plus"></i></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form-item>
    <!--商品图片组件-->
    <Upload v-if="is_upload" :config="config" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Uediter from '@/components/UE.vue'
import Upload from '@/components/file/Upload'
import draggable from 'vuedraggable'

export default {
  components: {
    /*编辑器*/
    Uediter,
    Upload,
    draggable
  },
  data () {
    return {
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        },
      },
      is_upload: false,
      config: {
        total: 9, fileType: 'image',
      }
    }
  },
  created () {

  },
  inject: ['form'],
  methods: {

    /*获取富文本框内容*/
    getContent: function () {
      //return this.$refs.ue.getUEContent();
    },
    /*获取富文本内容*/
    contentChangeFunc (e) {
      this.form.model.content = e
    },
    openUpload () {
      this.is_upload = true
    },
    /*上传商品图片*/
    returnImgsFunc (e) {
      console.log(e)
      console.log(this.form.model)
      if (e != null) {
        let imgs = this.form.model.contentImage.concat(e)
        this.$set(this.form.model, 'contentImage', imgs)
        // 兼容后端
        for (let i = 0; i < imgs.length; i++) {
          if (typeof (imgs[i].imageId) == 'undefined') {
            this.$set(imgs[i], 'imageId', imgs[i].fileId)
          }
        }
      }
      this.is_upload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.form.model.contentImage.splice(index, 1)
    },
  }
}
</script>

<style lang="css" scoped>
.labelStyle >>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Content.vue